<template lang="pug">
  div.side
    div.floor
      div.area
        Space
        div.area-inr(:style="{width: (c2p(this.width)) + 'px', height: (c2p(this.height)) + 'px', bottom: bottom + 'px'}")
          Items
          Slits
          Rails
    div.underfloor
</template>

<script>
import Items from './Items.vue';
import Rails from './Rails.vue';
import Slits from './Slits.vue';
import Space from './Space.vue';
export default{
  name: 'Side',
  components: {
    Items,
    Rails,
    Slits,
    Space
  },
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.allChange();
    },
    sets () {
      this.allChange();
    },
    view () {
      this.allChange();
    }
  },
  methods: {
    allChange () {
      this.set = this.sets[this.number];
      // すべて更新
      if (this.sets.length > 0 && this.set !== undefined) {
        this.width = this.set.size[2];
        this.height = this.set.size[1];
        this.bottom = this.c2p(this.set.size[3]);
      }
    }
  },
  created () {
    this.allChange();
  },
  mounted () {
  }

};
</script>

<style lang="stylus" scoped>
  .side
    display flex
    justify-content center
    align-items center
    font-size 20px
    font-weight bold
    position absolute
    left 0
    right 0
    top 0
    bottom 0
  .floor
    position absolute
    left 0
    right 0
    top 0
    bottom 86px
    z-index 1
    background url("../../assets/bg_grid.svg") left bottom
  .underfloor
    position absolute
    z-index 1
    left 0
    right 0
    bottom 0
    height 86px
    background-color #D9CE9C
  .area
    position absolute
    left 100px
    top 0
    bottom 0
    z-index 1
    &:before
      content ""
      display block
      width 5px
      height 100%
      position absolute
      left -5px
      top 0
      background-color #aaaaaa
    .area-inr
      position absolute
      left 0
      bottom 0
      // background-color #ff000033
      width 100px
      height 100px
</style>



// WEBPACK FOOTER //
// src/components/side/Side.vue